import { render, staticRenderFns } from "./TutorialButton.vue?vue&type=template&id=529c6c3c&lang=pug"
import script from "./TutorialButton.vue?vue&type=script&lang=js"
export * from "./TutorialButton.vue?vue&type=script&lang=js"
import style0 from "./TutorialButton.vue?vue&type=style&index=0&id=529c6c3c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports